import { render, staticRenderFns } from "./GetContainerBounds.vue?vue&type=template&id=48cd862a&"
import script from "./GetContainerBounds.vue?vue&type=script&lang=js&"
export * from "./GetContainerBounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports